module.exports = __webpack_public_path__ + "img/footer-logo.b752bc89.png";